import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UIState } from './ui.state';

export const selectUiState = createFeatureSelector<UIState>('ui');

export const selectGlobalLoading = createSelector(
  selectUiState,
  (state) => state.activeRequests > 0,
);

export const selectErrorMessage = createSelector(selectUiState, (state) => state.errorMessage);

export const selectSuccessMessage = createSelector(selectUiState, (state) => state.successMessage);
